import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();
  
  return (
    <Button
      onClick={toggleLanguage}
      variant="outline"
      size="sm"
      className={`flex items-center gap-2 bg-white/[0.03] border-white/10 hover:bg-[#d4af37]/10 hover:border-[#d4af37]/40 text-white h-11 px-4 rounded-xl transition-all ${className}`}
    >
      <Globe className="h-4 w-4 text-[#A1A1AA]" />
      <span className="font-medium text-[#A1A1AA]">
        {language === 'ar' ? 'EN' : 'ع'}
      </span>
    </Button>
  );
};

export default LanguageToggle;
